<template>
<div>
	<h2>Please wait... </h2>
</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'userProfile',
  props: ['dashboardName'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadUserProfile()
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity'
    ]),

    loadUserProfile () {
      // log login activity
      this.loadLogDashboardActivity({action: 'profile', page: 'profile', link: ''})
      // redirect to dashboard
      return this.$router.push({name: this.dashboardName, params: { forceShowProfile: true }})
    }
  },

  computed: {
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/user/components/UserProfile.vue